import { render } from "./EditUserSideNav.vue?vue&type=template&id=c0e76d08"
import script from "./EditUserSideNav.vue?vue&type=script&lang=js"
export * from "./EditUserSideNav.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__